

const SweatTextTitle = () => (
    <h1>

        {/* <img src="https://storage.googleapis.com/heldsolutionsllc-public-bucket/ic/sweattext_icon_nopad.png"
          width="100"
          alt="SweatText Logo"  /> */}

          SweatText SMS Reminders
        </h1>);

export default SweatTextTitle;